export enum Direction {
	Lower,
	Higher
}
